export default "__VITE_ASSET__CgQ9eOm8__"